import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";

import { Button, Stack } from "@mui/material";

import Certification from "./Certification";
import { CommonRoutesConfig } from "../../RoutesConfig";
import certificationService from "../../../services/certificationService";
import { CertificationHistoryPreviewDto, CertificationProps } from "../../../interfaces/Certification";
import { getRoutePath } from "./utils";
import usePrint from "../../../common/hooks/usePrint";
import CorrectionReason from "../../shared/CorrectionReason";
import PrintFooter from "../../../common/components/PrintFooter";

export default function HistoryPreview({ registerType }: CertificationProps) {
  const { id } = useParams();
  const historyId: number = parseInt(id as string);
  const navigate = useNavigate();
  const [certificationHistory, setCertificationHistory] = useState<CertificationHistoryPreviewDto>();
  const { printComponentRef, print } = usePrint();

  const routePath = getRoutePath(registerType);

  useEffect(() => {
    if (isNaN(historyId)) {
      navigate(CommonRoutesConfig.NotFound.Path, { replace: true });
    }

    (async () => {
      await certificationService
        .getCertificationHistoryAsync(historyId)
        .then(({ data: certificationHistory }) => setCertificationHistory(certificationHistory));
    })();
  }, []);

  const renderPrintTemplate = () => (
    <div style={{ display: "none" }}>
      <Stack spacing={3} ref={printComponentRef}>
        <Certification model={certificationHistory} />
        <CorrectionReason note={certificationHistory?.correctionReason} />
        <PrintFooter />
      </Stack>
    </div>
  );

  const renderPreview = () => (
    <Stack spacing={1}>
      <Stack direction="row-reverse">
        <Button startIcon={routePath.Print.Icon} onClick={print}>
          {routePath.Print.Label}
        </Button>
      </Stack>
      <Stack spacing={3}>
        <Certification model={certificationHistory} />
        <CorrectionReason note={certificationHistory?.correctionReason} />
      </Stack>
    </Stack>
  );

  return (
    <>
      {renderPreview()}
      {renderPrintTemplate()}
    </>
  );
}
